import CityScapeImage from 'assets/images/city-scape/city_creation_v6.jpg';
import { IDataPages } from 'common/contracts';
import { useResetModals } from 'common/hooks/useResetModals';
import LogoIcon from 'components/LogoIcon/LogoIcon';
import PointComp from 'components/PointComp/PointComp';
import { pageData } from 'data/pages';
import { CityScapeContainer, LinkItem } from 'pages/CityScape/CityScape.styles';
import { useEffect, useState } from 'react';
// import { useRouteMatch } from 'react-router-dom';

const CityScape = () => {
  useResetModals('all');
  // const match = useRouteMatch();

  const [data, setdata] = useState<IDataPages[]>([]);

  useEffect(() => {
    // filter children of city scape

    const q = pageData.filter(item => item.parentRoute === 'city-scape');

    setdata(q);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <LogoIcon />
      <CityScapeContainer>
        <img src={CityScapeImage} alt="city-scape" />
        {data.map((item: IDataPages, idx: number) => (
          <LinkItem key={idx} to={item?.route || '/'}>
            <PointComp position={item.pos} handleClick={() => {}}>
              {item.label}
            </PointComp>
          </LinkItem>
        ))}
      </CityScapeContainer>
    </>
  );
};

export default CityScape;
